import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import { type IResponseContactPipedriveIntegration } from 'entities/Contacts/api/types'
import { ContactIntegrationBase } from 'entities/Contacts/model/Integrations/ContactIntegrationBase'

export class ContactPipedrive extends ContactIntegrationBase<IResponseContactPipedriveIntegration> {
  integration_type: 'pipedrive'

  constructor(response: IResponseContactPipedriveIntegration) {
    super(response)

    makeAutoObservableSuper(this)

    this.integration_type = 'pipedrive'
    this.email = response.email.length ? response.email[0] : ''
    this.national_number = response.phones.length ? response.phones[0] : ''
    this.phone = this.national_number
  }
}
